import { render, staticRenderFns } from "./MemberQuit.vue?vue&type=template&id=2c2626dd&scoped=true&"
import script from "./MemberQuit.vue?vue&type=script&lang=js&"
export * from "./MemberQuit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2626dd",
  null
  
)

export default component.exports